import { expVal } from '@atlassian/jira-feature-experiments';

export default {
	get(): boolean {
		return expVal('bulk_operations_in_timeline', 'isEnabled', false);
	},
};
